(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CardPrefixConfigDeleteController',CardPrefixConfigDeleteController);

    CardPrefixConfigDeleteController.$inject = ['$uibModalInstance', 'entity', 'CardPrefixConfig'];

    function CardPrefixConfigDeleteController($uibModalInstance, entity, CardPrefixConfig) {
        var vm = this;

        vm.cardPrefixConfig = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CardPrefixConfig.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
